const labelsColors = {
  COMPLETE: {
    color: "#00DB97",
    backgroundColor: "#00DB4A08",
  },
  CONFIRMED: {
    color: "#00DB97",
    backgroundColor: "#00DB4A08",
  },
  IN_PROCESS: {
    color: "#D89611",
    backgroundColor: "#F4AC1B08",
  },
  CANCELED: {
    color: "#FE025C",
    backgroundColor: "#FE025C08",
  },
  // orders
  OPEN: {
    color: "#17a2b8",
    backgroundColor: "#17a2b808",
  },
  PENDING: {
    color: "#D89611",
    backgroundColor: "#F4AC1B08",
  },
  REFUNDED: {
    color: "#f44336",
    backgroundColor: "#f4433608",
  },
  WIN: {
    color: "#00DB97",
    backgroundColor: "#00DB4A08",
  },
  LOSE: {
    color: "#FE025C",
    backgroundColor: "#FE025C08",
  },
  BULL: {
    color: "#00DB97",
    backgroundColor: "#00DB4A08",
  },
  BEAR: {
    color: "#FE025C",
    backgroundColor: "#FE025C08",
  },
};

export default labelsColors;
